import React, {Component} from "react";
import {withStyles} from '@material-ui/core/styles';
import PropTypes from "prop-types";
import {FormControl, FormHelperText, InputLabel, NativeSelect, Select} from "@material-ui/core";

const styles = (theme) => ({
  filterControl: {
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(1),
    minWidth: 140,
  },
  label: {
    transform: 'translate(14px, 10px) scale(0.75) !important'
  },
  select: {
    paddingTop: 26,
    paddingBottom: 11
  }
});

class OutlineSelect extends Component {

  static propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.string,
    value: PropTypes.string,
    fullWidth: PropTypes.bool,
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
    helperText: PropTypes.node,
    classes: PropTypes.object,
    error: PropTypes.bool,
    autofill: PropTypes.string,
    children: PropTypes.object,
  };

  static defaultProps = {
    onChange: () => {}
  };

  constructor(props) {
    super(props);
  }

  render() {
    const {id, label, value, onChange, fullWidth, disabled, helperText, autofill, classes, error, children} = this.props;
    return (
      <FormControl variant="outlined" className={classes.filterControl} fullWidth={fullWidth} disabled={disabled} error={error}>
        <InputLabel
          classes={{root: classes.label}}
          id={id + '-label'}
        >
          {label}
        </InputLabel>
        <Select
          native
          labelId={id + '-label'}
          id={id + '-select'}
          classes={{select: classes.select}}
          value={value}
          variant="outlined"
          onChange={onChange}
          autofill={autofill}
        >
          {children}
        </Select>
        {helperText &&
         <FormHelperText>
           {helperText}
         </FormHelperText>
        }
      </FormControl>
    );
  }
}

export default withStyles(styles)(OutlineSelect);
